import React from "react";
import clsx from "clsx";
import "./CommonButton.scss";

const CommonButton = ({
  children = "버튼",
  size,
  theme,
  color,
  style,
  onClick,
  ...props
}) => {
  const inlineStyles = {
    ...style, // 추가적인 인라인 스타일을 덮어쓰기
  };

  const handleClick = (e) => {
    e.preventDefault();

    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button
      className={clsx("button", theme, size, color)}
      style={inlineStyles}
      onClick={handleClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default CommonButton;
